import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className='flex justify-center items-center mt-50px '>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner
